$(document).ready(function(){
	if($(".step3-form").length > 0){
		var email_field = $("input[name='contact[email]']");
		var tel_field = $("input[name='contact[tel]']");
		if(email_field.val() && email_field.val().length > 0) { display_confirm_action(email_field, "email"); }
		if(tel_field.val() && tel_field.val().length > 0) { display_confirm_action(tel_field, "tel"); }
		convert_tel_to_sigle_byte_and_remove_hyphen(tel_field);
		convert_email_to_sigle_byte_and_remove_hyphen(email_field);
		display_confirm_email_text(email_field);
		display_confirm_tel_text(tel_field);
	}
});

function convert_tel_to_sigle_byte_and_remove_hyphen(tel_field) {
	tel_field.change(function(){
		var inputted_tel = $(this).val();
		var single_byte_tel = textreplace(inputted_tel);
		var final_tel = single_byte_tel.replace(/-/g, "");
		$(this).val(final_tel);
		display_confirm_action($(this), "tel");
	});
}

function convert_email_to_sigle_byte_and_remove_hyphen(email_field) {
	email_field.change(function(){
		var inputted_email = $(this).val();
		var single_byte_mail = textreplace(inputted_email);
		$(this).val(single_byte_mail);
		display_confirm_action($(this), "email");
	});
}

function display_confirm_email_text(email_field) {
	email_field.on('input', function(){
		display_confirm_action($(this), "email");
	});
}

function display_confirm_tel_text(tel_field) {
	tel_field.on('input', function(){
		display_confirm_action($(this), "tel");
	});
}

function textreplace(str){
	var han = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s){ return String.fromCharCode(s.charCodeAt(0)-0xFEE0); });
	zenkakuArr = "ー－＠＿。．＋";
	hankakuArr = "--@_..+";
	for(i=0; i<zenkakuArr.length; i++){
		reg = new RegExp(zenkakuArr[i], "g");
		han = han.replace(reg, hankakuArr[i]);
	}
	return han;
}

function display_confirm_action(current, field_name) {
	$(".confirm-screen__" + field_name).remove();
	if(current.val().length > 0){
		confirm_html = make_html(current.val(), field_name)
		$(".wrapper_" + field_name).after(confirm_html);
	}
}

function make_html(input_text, field_name) {
	if(input_text == "") return "";
	var display_html = "<div class='confirm-screen confirm-screen__" + field_name + "'>" +
		"<div class='confirm-screen__inner confirm-screen__" + field_name + "'>" +
		"<div class='confirm-screen__inner__title confirm-screen__" + field_name + "__title'>！ご確認ください！</div>" +
		"<div class='confirm-screen__inner__value confirm-screen__" + field_name + "__value'>" + input_text + "</div>" +
		"<div class='confirm-screen__inner__footer confirm-screen__" + field_name + "__footer'>入力ミスが多くなっていますので、いま一度ご確認ください。</div>" +
		"</div></div>";
	return display_html
}